import { FilterMatchMode } from 'primereact/api';
import { ColumnProps } from 'primereact/column';

export const getTableColumns = (): ColumnProps[] => {
  return [
    {
      field: 'checkbox',
      selectionMode: 'multiple',
      style: { width: '3rem' },
    },
    {
      field: 'codigo',
      header: 'Código',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'nombre',
      header: 'Nombre',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
  ];
};

export const tableFilters = {
  codigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
